module.exports = __webpack_public_path__ + "static/media/wsymbol_0004_black_low_cloud_big_s1.510b2f41.png";